var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container has-background-white-ter"},[_c('section',{staticClass:"section"},[_c('router-view',{staticClass:"is-fullheight"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }